<!-- 专利 -->
<template>
  <div class="development">
    <div class="main">
      <div class="content">
        <div class="main_box">
          <div class="table">
            <table>
              <thead>
                <tr>
                  <th style="width: 9%">授权类型</th>
                  <th>专利类型</th>
                  <th>专利申请号</th>
                  <th style="width: 17%">专利名称</th>
                  <th>专利领域</th>
                  <th style="width: 9%">价格区间</th>
                  <th style="width: 13%">案源时间</th>
                  <th style="width: 9%">审核状态</th>
                  <th style="width: 9%">操作</th>
                </tr>
              </thead>
              <tbody>
                <!-- <tr v-for="item in 16" :key="item">
                  <td style="width: 9%">审查中</td>
                  <td>实用新型</td>
                  <td>2021216676147</td>
                  <td style="width: 17%">一种便于回充的UPS电源</td>
                  <td></td>
                  <td style="width: 9%">面议</td>
                  <td style="width: 13%">2026-12-31 15:31:22</td>
                  <td style="width: 9%"></td>
                  <td class="edit" style="width: 9%">编辑</td>
                </tr> -->
                <tr v-for="item in patentList" :key="item.id">
                  <td style="width: 9%">{{ item.authorization_type }}</td>
                  <td>{{ item.patent_classification }}</td>
                  <td>{{ item.application_number }}</td>
                  <td style="width: 17%">{{ item.title }}</td>
                  <td>{{ item.field }}</td>
                  <td style="width: 9%">
                    {{ formatPrice(item.exclusive_selling_price) }}
                  </td>
                  <td style="width: 13%">{{ item.publication_date }}</td>
                  <td style="width: 9%">{{ formatStatus(item.status) }}</td>
                  <td class="edit" style="width: 9%" @click="handleEdit(item)">
                    编辑
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="paging">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getMyPatent } from "../../api/userApi";
export default {
  data() {
    return {
      patentList: [], // 专利列表数据
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示条数
      total: 0, // 总数据量
      loading: false, // 加载状态
    };
  },
  created() {
    this.fetchPatentList();
  },
  methods: {
    // 获取专利列表
    async fetchPatentList() {
      this.loading = true;
      try {
        const params = {
          page: this.currentPage,
          limit: this.pageSize,
          // 如果需要按状态筛选，可以添加 status 参数
          // status: this.filterStatus
        };

        const response = await getMyPatent(params);

        if (response.code === 1) {
          this.patentList = response.data;
          this.total = response.count;
        } else {
          this.$message.error("获取专利列表失败");
        }
      } catch (error) {
        console.error("获取专利列表出错:", error);
        this.$message.error("获取专利列表出错");
      } finally {
        this.loading = false;
      }
    },

    // 格式化价格显示
    formatPrice(price) {
      if (!price || price === "0") return "面议";
      return price;
    },

    // 格式化状态显示
    formatStatus(status) {
      const statusMap = {
        0: "待审核",
        1: "通过",
        2: "驳回",
      };
      return statusMap[status] || "未知状态";
    },

    // 编辑专利
    handleEdit(item) {
      this.$router.push({
        path: "/memberCenter/publish-patent",
        query: {
          id: item.id,
          mode: "edit", // 添加模式标识，用于区分新建和编辑
        },
      });
    },

    // 每页条数变化
    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchPatentList();
    },

    // 当前页码变化
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchPatentList();
    },
  },
};
</script>

<style scoped lang="less">
.content {
  width: 100%;
  max-width: 87.5rem;
  margin: 0 auto;
  //   position: absolute;
}
.main {
  background: #f5f5f5;
  width: 100%;
  .main_box {
    width: 100%;
    // height: 1017px;
    background: #fff;
    border-radius: 10px;
    // padding: 15px 40px 35px 40px;
    .table {
      //   width: 100%;
      table {
        width: 100%;
        border-collapse: collapse; /* 合并单元格边框 */
        border-spacing: 0; /* 移除单元格之间的间距 */
        margin: 15px 0 35px 0;
        th,
        td {
          /* 强制不换行 */
          white-space: nowrap;
          /* 内容超出容器隐藏 */
          overflow: hidden;
          /* 使用省略号表示被隐藏的内容 */
          text-overflow: ellipsis;
          /* 设置最大宽度或固定宽度 */
          width: 11%; /* 根据实际情况调整 */
          /* 确保内容不会自动扩展td的宽度 */
          display: inline-block;
          /* 可选：设定一个固定高度，如果适用 */
          height: 50px; /* 根据实际情况调整 */
          line-height: 50px;
        }
        thead {
          border-radius: 5px;
          background: #175dc2;

          tr {
            height: 50px;
            th {
              // width: 10%;
              font-family: PingFang SC, PingFang SC;

              font-weight: 600;
              font-size: 14px;
              color: #ffffff;
            }
          }
        }
        tbody {
          tr:nth-child(odd) {
          }
          tr:nth-child(even) {
            background: #f2f4fe;
            border-radius: 5px;
          }
          tr {
            td {
              // height: 50px;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 14px;
              color: #121212;
              // white-space: nowrap; /* 禁止文字换行 */
              // overflow: hidden; /* 超出部分隐藏 */
              // text-overflow: ellipsis;
            }
          }
          .edit {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #175dc2;
            cursor: pointer;
          }
        }
      }
    }
    .paging {
      display: flex;
      justify-content: flex-end;
      padding-right: 45px;
      margin-bottom: 18px;
    }
  }
}
</style>
